// @i18n-ignore-file
export const LOCAL_STORAGE_NEW_CART_ID_KEY = 'new::cart::key::lastbrand'
export const LOCAL_STORAGE_CART_OBJ_KEY = 'new::cart::data::lastbrand'
export const LOCAL_STORAGE_PREV_CART_ID_KEY = 'prev::cart::key::lastbrand'
export const CART_AUTH_CODE_KEY = 'cart::code::key::A'
export const CHECKOUT_AUTH_CODE_KEY = 'checkout::code::key::A'
export const PRIORITY_INVENTORY_TYPE = ['NORMAL', 'MTO', 'PRE_ORDER']
export const CART_AUTH_CODE_RES_KEY = 'cart-auth-code'
export const CHECKOUT_AUTH_CODE_RES_KEY = 'auth-code'
export const CHECKOUT_TEST_KEY_VALUE = 'checkout_dev_view'
export const CHECKOUT_TEST_PARAM_VALUE = 'checkout_dev_view'
export const SIDE_TOAST_ERROR_KEY = 'Side:Toast:Error'

export const CART_CHECKOUT_ID_KEY = 'cart::checkout::id::lastbrand'
export const CART_CHECKOUT_OBJ_KEY = 'cart::checkout::obj::lastbrand'

export const LOCAL_STORAGE_PREV_CHECKOUT_ID_KEY = 'prev::checkout::key::lastbrand'

export const STORE_PROGRAM_ID_KEY = 'storeProgramId'
export const ID_TOKEN_KEY = 'idToken'
export const B2B_URL_PREFIX = 'b2b'
export const B2B_SOURCE = 'b2b'
export const B2B_AUTO_SIGNED_IN_PARAM = 'auto_signed_in'
// eslint-disable-next-line i18next/no-literal-string -- storage key, not UI copy
export const B2B_AUTO_SIGNED_IN_SHOWN_KEY = 'b2b_auto_signed_in_shown'
